// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"e9ab6deb","498":"9e6cb2e4","703":"6fffbed4"}[chunkId] + ".chunk.js";
};